import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountJulaClubOverview';

const AccountJulaClubOverviewSuspense = dynamic(
	() => import('./AccountJulaClubOverview'),
	{ loading: () => <BlockLoadingSpinner /> },
);

export default function DynamicAccountJulaClubOverview(props: Props) {
	return <AccountJulaClubOverviewSuspense {...props} />;
}
DynamicAccountJulaClubOverview.displayName = 'DynamicAccountJulaClubOverview';
